// Schedule the next request after the previous one finishes: slow ML/API calls
// must not create overlapping requests or update an unmounted session page.
export function pollSessionAnalysis({ load, onData, onError, interval = 5000 }) {
    let stopped = false;
    let timer;
    const controller = new AbortController();
    const schedule = () => { if (!stopped) timer = setTimeout(tick, interval); };
    async function tick() {
        try {
            const snapshot = await load(controller.signal);
            if (stopped) return;
            onData(snapshot);
            if (snapshot.row.mlProcessingPending || snapshot.row.mlResultStatus === 'processing') schedule();
        } catch (error) {
            if (stopped) return;
            onError(error);
            if (![401, 403, 404].includes(error.response?.status)) schedule();
        }
    }
    tick();
    return () => { stopped = true; clearTimeout(timer); controller.abort(); };
}
